import Text from '@/common/components/atom/text';
import { useRouter } from 'next/router';
import { areaEmptyTitle, cleanListingPath, hasActiveFilter, listingNames, parentListingHref, specialtyWithCity } from '../../functions/areaPages';
import { freeturnItems } from '../../components/filters/sort';
import { useSearch } from '../../hooks/useSearch';

/**
 * DR-43. On an area page a filter (today, a sort, a gender…) can empty a tiny neighbourhood, and the generic empty state
 * says «عبارات کامل‌تری وارد کنید» — advice for a text search, wrong here. This says what happened, in the words of the
 * filter, and gives the two ways out as plain links: drop the filter, or see every doctor of the specialty in the city.
 */
export const AreaEmptyState = () => {
  const { area, seoInfo } = useSearch();
  const { asPath } = useRouter();
  if (!area) return null;

  const names = listingNames((seoInfo as any)?.jsonld, true, area.name_fa);
  const filtered = hasActiveFilter(asPath);
  const allText = names ? `همهٔ پزشکان ${specialtyWithCity(names.group, names.city).withCity}` : 'همهٔ پزشکان این تخصص در شهر';

  return (
    <section data-testid="area-empty" className="flex flex-col items-center w-full p-5 space-y-4 text-center bg-white rounded-lg">
      <Text as="p" fontWeight="bold">
        {areaEmptyTitle(area.name_fa, asPath, freeturnItems)}
      </Text>
      <div className="flex flex-col w-full gap-2 md:flex-row md:justify-center">
        {filtered && (
          <a
            href={cleanListingPath(asPath)}
            className="inline-flex items-center justify-center min-h-[44px] px-5 text-sm font-medium text-white rounded-lg bg-primary"
          >
            حذف فیلتر
          </a>
        )}
        <a
          href={parentListingHref(asPath)}
          className="inline-flex items-center justify-center min-h-[44px] px-5 text-sm font-medium bg-white border rounded-lg border-primary text-primary"
        >
          {allText}
        </a>
      </div>
    </section>
  );
};

export default AreaEmptyState;
